import { Locale } from '@finxone-platform/form-action';
import { AlertTypes } from '@finxone-platform/shared/sys-config-types';
import { HttpErrorCode } from '../error-codes/http-error.type';
import { defaultHttpTranslations } from './en-GB/http-error';
import { SupportedToasterLocales } from './general.utils';

export const httpErrorTranslations: {
  // For new locales just add them here to the extract
  [key in SupportedToasterLocales]: typeof defaultHttpTranslations;
} = {
  [Locale.en_GB]: defaultHttpTranslations,
  // Add more locales as needed
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateHttpErrorAlerts = (translations: typeof defaultHttpTranslations) => ({
  [HttpErrorCode.STATUS_400]: {
    name: '400',
    type: AlertTypes.ERROR,
    title: translations.STATUS_400_TITLE,
    description: translations.STATUS_400_DESCRIPTION,
  },
  [HttpErrorCode.STATUS_401]: {
    name: '401',
    type: AlertTypes.ERROR,
    title: translations.STATUS_401_TITLE,
    description: translations.STATUS_401_DESCRIPTION,
  },
  [HttpErrorCode.STATUS_402]: {
    name: '402',
    type: AlertTypes.ERROR,
    title: translations.STATUS_402_TITLE,
    description: translations.STATUS_402_DESCRIPTION,
  },
  [HttpErrorCode.STATUS_403]: {
    name: '403',
    type: AlertTypes.ERROR,
    title: translations.STATUS_403_TITLE,
    description: translations.STATUS_403_DESCRIPTION,
  },
  [HttpErrorCode.STATUS_404]: {
    name: '404',
    type: AlertTypes.ERROR,
    title: translations.STATUS_404_TITLE,
    description: translations.STATUS_404_DESCRIPTION,
  },
  [HttpErrorCode.STATUS_405]: {
    name: '405',
    type: AlertTypes.ERROR,
    title: translations.STATUS_405_TITLE,
    description: translations.STATUS_405_DESCRIPTION,
  },

  [HttpErrorCode.STATUS_4XX_CATCH_ALL_ERROR]: {
    name: '4xx Catch-All Error',
    type: AlertTypes.ERROR,
    title: translations.STATUS_4XX_CATCH_ALL_ERROR_TITLE,
    description: translations.STATUS_4XX_CATCH_ALL_ERROR_DESCRIPTION,
  },

  //500
  [HttpErrorCode.STATUS_500]: {
    name: '500',
    type: AlertTypes.ERROR,
    title: translations.STATUS_500_TITLE,
    description: translations.STATUS_500_DESCRIPTION,
  },
  [HttpErrorCode.STATUS_501]: {
    name: '501',
    type: AlertTypes.ERROR,
    title: translations.STATUS_501_TITLE,
    description: translations.STATUS_501_DESCRIPTION,
  },
  [HttpErrorCode.STATUS_502]: {
    name: '502',
    type: AlertTypes.ERROR,
    title: translations.STATUS_502_TITLE,
    description: translations.STATUS_502_DESCRIPTION,
  },
  [HttpErrorCode.STATUS_503]: {
    name: '503',
    type: AlertTypes.ERROR,
    title: translations.STATUS_503_TITLE,
    description: translations.STATUS_503_DESCRIPTION,
  },
  [HttpErrorCode.STATUS_504]: {
    name: '504',
    type: AlertTypes.ERROR,
    title: translations.STATUS_504_TITLE,
    description: translations.STATUS_504_DESCRIPTION,
  },
  [HttpErrorCode.STATUS_505]: {
    name: '505',
    type: AlertTypes.ERROR,
    title: translations.STATUS_405_TITLE,
    description: translations.STATUS_505_DESCRIPTION,
  },
  [HttpErrorCode.STATUS_5XX_CATCH_ALL_ERROR]: {
    name: '5xx Catch-All Error',
    type: AlertTypes.ERROR,
    title: translations.STATUS_5XX_CATCH_ALL_ERROR_TITLE,
    description: translations.STATUS_5XX_CATCH_ALL_ERROR_DESCRIPTION,
  },
});
